import loggly from '@software/ccra-loggly';
import { ExtendedLogger } from './extended-logger';
export function StandardLogger(name) {
    const log = new ExtendedLogger(loggly, name);
    return log;
}
export { configure as configureLogging } from '@software/ccra-loggly/dist/log-configuration';
//# sourceMappingURL=standard-logger.js.map